module.exports = __webpack_public_path__ + "static/media/meta_ai.2917c51c.png";